import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/FilePpt.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: i }));
o.displayName = "FilePptIcon";
const c = o;
export {
  c as FilePpt,
  o as FilePptIcon
};
